import { all, both, isNil, propSatisfies } from 'ramda'
import { isNotNil } from 'ramda-adjunct'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const hasNoError = propSatisfies(isNil, `error`)

const hasData = propSatisfies(isNotNil, `data`)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const wasResultSuccessful = both(hasNoError, hasData)

export const wereAllResultsSuccessful = all(wasResultSuccessful)
